import axios from "axios";
import { action, observable, autorun, runInAction, makeObservable } from "mobx";

class AdminStore {
  dashboard = {};
  users = [];
  questions = [];
  areas = [];
  charges = [];
  competences = [];

  constructor() {
    makeObservable(this, {
      dashboard: observable,
      users: observable,
      questions: observable,
      areas: observable,
      charges: observable,
      competences: observable,
    });
  }

  @action
  async getDashboard() {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/dashboard`
    );
    const { data } = response;
    runInAction(() => {
      this.dashboard = data;
    });
  }

  @action
  async getUsers() {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/users`
    );
    const { data } = response;
    runInAction(() => {
      this.users = data.data;
    });
  }

  @action
  async getQuestions() {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/admin/questions`
    );
    const { data } = response;
    runInAction(() => {
      this.questions = data.data;
    });
  }

  @action
  async getCompetences() {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/competences/all`
    );
    const { data } = response;
    const { competences } = data;
    runInAction(() => {
      this.competences = competences;
    });
  }

  @action
  async submitCompetence(comp) {
    let url = `${process.env.REACT_APP_API_URL}/admin/competences`;
    let fn = axios.post;
    if (comp.id) {
      url += `/${comp.id}`;
      fn = axios.put;
    }
    await fn(url, comp);
    await this.getCompetences();
  }

  @action
  async deleteCompetence(id) {
    let url = `${process.env.REACT_APP_API_URL}/admin/competence/${id}`;
    await axios.delete(url);
    await this.getCompetences();
  }

  @action
  async getAreas() {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/areas/all`
    );
    const { data } = response;
    const { areas } = data;
    runInAction(() => {
      this.areas = areas;
    });
  }

  @action
  async submitArea(area) {
    let url = `${process.env.REACT_APP_API_URL}/admin/areas`;
    let fn = axios.post;
    if (area.id) {
      url += `/${area.id}`;
      fn = axios.put;
    }
    await fn(url, area);
    await this.getAreas();
  }

  @action
  async deleteArea(id) {
    let url = `${process.env.REACT_APP_API_URL}/admin/areas/${id}`;
    await axios.delete(url);
    await this.getAreas();
  }

  @action
  async getCharges() {
    const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/cargos/all`
    );
    const { data } = response;
    const { cargos } = data;
    runInAction(() => {
      this.charges = cargos;
    });
  }

  @action
  async submitCharge(charge) {
    let url = `${process.env.REACT_APP_API_URL}/admin/cargos`;
    let fn = axios.post;
    if (charge.id) {
      url += `/${charge.id}`;
      fn = axios.put;
    }
    await fn(url, charge);
    await this.getCharges();
  }

  @action
  async deleteCharge(id) {
    let url = `${process.env.REACT_APP_API_URL}/admin/cargos/${id}`;
    await axios.delete(url);
    await this.getCharges();
  }

  @action
  async submitQuestion(question) {
    let url = `${process.env.REACT_APP_API_URL}/admin/questions`;
    let fn = axios.post;
    if (question.id) {
      url += `/${question.id}`;
      fn = axios.put;
    }
    await fn(url, question);
    await this.getQuestions();
  }

  @action
  async deleteQuestion(id) {
    let url = `${process.env.REACT_APP_API_URL}/admin/questions/${id}`;
    await axios.delete(url);
    await this.getQuestions();
  }

  @action
  async submitAnswer(answer) {
    let url = `${process.env.REACT_APP_API_URL}/admin/answers`;
    let fn = axios.post;
    if (answer.id) {
      url += `/${answer.id}`;
      fn = axios.put;
    }
    const response = await fn(url, answer);
    return response.data;
  }

  @action
  async deleteAnswer(id) {
    let url = `${process.env.REACT_APP_API_URL}/admin/answers/${id}`;
    await axios.delete(url);
  }
}

const adminStore = new AdminStore();
export default adminStore;
autorun(() => {
  adminStore.getDashboard();
  adminStore.getUsers();
  adminStore.getQuestions();
  adminStore.getAreas();
  adminStore.getCharges();
  adminStore.getCompetences();
});
